var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 67,
    viewBox: "0 0 49 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0909,
    d: "M43.9364 45.0634C43.9364 45.0634 40.8499 43.9497 40.7689 43.9979L38.4642 43.3233C37.4856 42.8039 35.094 43.0395 34.3181 43.4518L20.2236 50.0429L19.0076 50.6105L3.69713 57.7745C2.6606 58.326 1.84991 59.3058 1.84991 60.2749C1.84991 60.4463 1.83833 60.6337 1.86728 60.7996C2.01784 61.7045 2.65481 62.5773 3.79557 63.1823C3.79557 63.1823 4.30515 63.4072 5.00002 63.6909C6.1929 64.1835 8.08644 64.8582 9.78889 65.4632C11.6824 66.1325 13.686 66.6358 14.2014 66.6358C15.2842 66.6358 16.4424 66.3253 17.2125 65.9076L30.0851 59.0702L31.5444 58.2938L45.882 50.6854C46.9185 50.1339 47.7003 49.1594 47.7003 48.185C47.7003 47.9173 47.5845 47.6228 47.3239 47.3497C46.5595 46.5251 44.9671 45.6096 43.9364 45.0634Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1818,
    d: "M44.0637 45.2992C44.0637 45.2992 41.1279 44.2016 40.9599 44.2926L38.7132 43.7679C37.833 43.2968 35.3778 43.6555 34.6829 44.0303L20.9069 50.4929L19.7198 51.0497L4.751 58.0692C3.81871 58.5671 2.85167 59.563 2.85167 60.4358C2.85167 60.5911 2.81113 60.7785 2.82272 60.9284C2.91537 61.7904 3.4539 62.6632 4.58307 63.2628C4.58307 63.2628 5.1216 63.5145 5.74699 63.7715C6.93408 64.2641 8.79866 64.8477 10.4143 65.3778C12.1341 65.9453 14.2129 66.2773 14.6762 66.2773C15.649 66.2773 16.8882 65.8918 17.5831 65.517L30.0793 58.8777L31.498 58.1227L45.4187 50.7285C46.351 50.2305 47.266 49.24 47.266 48.3672C47.266 48.1263 47.2138 47.8372 46.9938 47.5802C46.351 46.8145 45.0945 45.8507 44.0637 45.2992Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2727,
    d: "M44.1911 45.54C44.1911 45.54 41.4058 44.4584 41.1568 44.5922L38.968 44.2174C38.1862 43.7998 35.6673 44.2763 35.0477 44.6083L21.5844 50.9371L20.4263 51.4778L5.79331 58.3581C4.96525 58.7971 3.83607 59.8144 3.83607 60.5908C3.83607 60.73 3.7608 60.9174 3.76659 61.0513C3.80712 61.8812 4.23563 62.7379 5.35901 63.3376C5.35901 63.3376 5.9265 63.616 6.47661 63.8462C7.65211 64.3442 9.49354 64.8261 11.0223 65.2919C12.5684 65.7577 14.7225 65.9183 15.1336 65.9183C15.9964 65.9183 17.3167 65.4579 17.9363 65.1312L30.0677 58.6847L31.4401 57.9565L44.9497 50.7764C45.7778 50.3374 46.8259 49.3308 46.8259 48.5544C46.8259 48.3402 46.8374 48.0565 46.6579 47.8102C46.1368 47.098 45.2276 46.0914 44.1911 45.54Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3636,
    d: "M44.3186 45.781C44.3186 45.781 41.6839 44.7155 41.3538 44.8922L39.2228 44.6673C38.5395 44.3032 35.9627 44.9029 35.4184 45.1921L22.2678 51.387L21.1386 51.917L6.8415 58.6527C6.11767 59.0382 4.82635 60.0716 4.82635 60.7516C4.82635 60.8694 4.68738 61.0621 4.71054 61.1799C4.51366 61.9616 5.02324 62.8237 6.13504 63.418C6.13504 63.418 6.73148 63.7178 7.2121 63.9267C8.37602 64.4246 10.1943 64.8155 11.6362 65.2063C13.0028 65.5758 15.2379 65.5597 15.597 65.5597C16.3555 65.5597 17.7511 65.0296 18.2896 64.7405L30.0504 58.4867L31.3823 57.78L44.4807 50.8194C45.2046 50.4339 46.3859 49.4112 46.3859 48.7312C46.3859 48.5438 46.5133 48.2279 46.3222 48.0352C46.0905 47.2963 45.3551 46.3379 44.3186 45.781Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4545,
    d: "M44.446 46.022C44.446 46.022 41.9618 44.9725 41.5449 45.1921L39.4776 45.1171C38.8927 44.8066 36.2522 45.524 35.789 45.7703L22.9453 51.8367L21.8451 52.3561L7.8896 58.9472C7.27 59.2792 5.81655 60.3286 5.81655 60.9122C5.81655 61.0139 5.63704 61.2067 5.66019 61.3084C5.35908 62.0527 5.81075 62.9093 6.91677 63.4983C6.91677 63.4983 7.54216 63.8303 7.95329 64.007C9.10563 64.5049 10.8892 64.7994 12.25 65.126C13.4313 65.4044 15.7533 65.2117 16.0602 65.2117C16.7088 65.2117 18.1854 64.6067 18.6486 64.3604L30.0388 58.3047L31.3302 57.6193L44.0117 50.8729C44.6313 50.541 45.9458 49.5076 45.9458 48.924C45.9458 48.7634 46.1484 48.4421 45.9863 48.2761C45.9226 47.564 45.4825 46.5788 44.446 46.022Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5455,
    d: "M44.5734 46.2628C44.5734 46.2628 42.2397 45.2241 41.7417 45.4918L39.7324 45.5667C39.246 45.3044 36.5417 46.145 36.1538 46.3538L23.6228 52.2864L22.5515 52.795L8.93192 59.2416C8.41655 59.52 6.80676 60.5855 6.80676 61.0727C6.80676 61.1584 6.5867 61.3511 6.60408 61.4368C6.19873 62.1382 6.59829 62.9949 7.69272 63.5785C7.69272 63.5785 8.34707 63.9373 8.68872 64.0872C9.82948 64.5851 11.5493 64.9974 12.8638 65.0402C13.8019 65.3936 16.2629 64.8528 16.5235 64.8528C17.062 64.8528 18.6197 64.1782 19.0077 63.9694L30.0273 58.1065L31.2723 57.4425L43.5484 50.9103C44.0638 50.6319 45.5115 49.5825 45.5115 49.1006C45.5115 48.9667 45.7952 48.6401 45.6562 48.5009C45.7547 47.8316 45.6157 46.8197 44.5734 46.2628Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6364,
    d: "M44.7009 46.5037C44.7009 46.5037 42.5179 45.481 41.9388 45.7916L39.9873 46.0164C39.5936 45.8076 36.8372 46.7714 36.5245 46.932L24.3063 52.7307L23.2639 53.2233L9.98018 59.5306C9.56904 59.7501 7.7971 60.8371 7.7971 61.2279C7.7971 61.2975 7.53652 61.4903 7.55389 61.5599C7.05011 62.2185 7.39175 63.0752 8.4804 63.6534C8.4804 63.6534 9.15791 64.0389 9.43007 64.1621C10.5592 64.6654 12.2501 65.0134 13.4835 64.9545C14.2363 65.2383 16.7842 64.494 16.9927 64.494C17.427 64.494 19.0599 63.7444 19.3668 63.5785L30.0158 57.9136L31.2203 57.2711L43.0795 50.9584C43.4907 50.7389 45.0773 49.6734 45.0773 49.2825C45.0773 49.1755 45.4363 48.8381 45.3263 48.7311C45.5811 48.0992 45.7432 47.0605 44.7009 46.5037Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7273,
    d: "M44.8224 46.7394C44.8224 46.7394 42.7898 45.7328 42.1239 46.0861L40.2362 46.4609C39.9408 46.3057 37.1208 47.3872 36.8892 47.5104L24.9836 53.1752L23.9702 53.6571L11.0281 59.8198C10.7154 59.9858 8.78712 61.0888 8.78712 61.3779C8.78712 61.4315 8.4918 61.6242 8.49759 61.6778C7.88957 62.2935 8.17331 63.1502 9.25617 63.7231C9.25617 63.7231 9.96263 64.1354 10.1653 64.2264C11.2829 64.7297 12.939 65.0242 14.0972 64.8529C14.6588 65.067 17.2994 64.1193 17.4557 64.1193C17.78 64.1193 19.494 63.2948 19.7257 63.1716L30.0041 57.6996L31.1622 57.0838L42.6161 51.0014C42.9288 50.8354 44.6428 49.7538 44.6428 49.4647C44.6428 49.3844 45.0771 49.0417 44.9961 48.9614C45.413 48.3671 45.8705 47.3016 44.8224 46.7394Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8182,
    d: "M44.9498 46.9803C44.9498 46.9803 43.0678 45.9898 42.3208 46.386L40.491 46.9107C40.2941 46.809 37.4104 48.0083 37.2598 48.094L25.6669 53.6303L24.6825 54.1015L12.0763 60.1197C11.8678 60.2321 9.78316 61.3512 9.78316 61.5439C9.78316 61.5761 9.44731 61.7742 9.4531 61.8116C8.74664 62.3845 8.97247 63.2359 10.0437 63.8088C10.0437 63.8088 10.7734 64.2532 10.9123 64.3121C12.0184 64.8154 13.6455 65.051 14.7168 64.7779C15.0932 64.9171 17.8206 63.7713 17.9248 63.7713C18.1391 63.7713 19.9342 62.8771 20.0905 62.7915L29.9983 57.5175L31.1159 56.9232L42.1471 51.0495C42.3556 50.9371 44.2028 49.8448 44.2028 49.6467C44.2028 49.5932 44.7182 49.2452 44.6661 49.1916C45.2451 48.6348 46.0037 47.5425 44.9498 46.9803Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9091,
    d: "M45.077 47.2213C45.077 47.2213 43.3456 46.2415 42.5176 46.6859L40.7456 47.3605C40.6472 47.307 37.7055 48.6295 37.6245 48.6723L26.3443 54.0748L25.3888 54.5299L13.1184 60.4089C13.0142 60.4624 10.7674 61.6029 10.7674 61.6993C10.7674 61.7153 10.391 61.9134 10.391 61.9349C9.58033 62.4649 9.75406 63.3163 10.8137 63.8838C10.8137 63.8838 11.5723 64.355 11.6418 64.3871C12.7362 64.8958 14.3345 65.0671 15.3247 64.687C15.51 64.7566 18.33 63.4126 18.3821 63.4126C18.4921 63.4126 20.3625 62.4435 20.4436 62.406L29.9808 57.3248L31.0579 56.7519L41.6837 51.0924C41.7879 51.0389 43.7683 49.9252 43.7683 49.8288C43.7683 49.8021 44.359 49.4487 44.3358 49.4219C45.077 48.9026 46.1309 47.7835 45.077 47.2213Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.9444 64.6012L29.9693 57.1266L43.9943 49.6574C44.9092 49.1702 46.2584 48.0244 45.2045 47.4622C45.2045 47.4622 43.6237 46.4984 42.7087 46.9856L27.0277 54.5245L11.3466 62.0633C10.4317 62.5505 10.5475 63.4018 11.6014 63.964L12.3831 64.4673C13.437 65.0295 15.0352 65.0884 15.9444 64.6012Z",
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66352 35.565L45.9397 22.3613V48.5651V48.6133C46.0671 49.4647 45.5749 50.2946 44.4457 50.8996L18.5615 64.7618C16.3205 65.9612 12.4003 65.8113 9.81185 64.4245C8.43947 63.691 7.72143 62.7647 7.67511 61.8759L7.66352 61.8812V35.565Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M15.5042 62.101C13.5597 62.101 11.9835 56.3574 11.9835 49.2722C11.9835 42.187 13.5597 36.4434 15.5042 36.4434C17.4486 36.4434 19.0249 42.187 19.0249 49.2722C19.0249 56.3574 17.4486 62.101 15.5042 62.101Z",
    fill: "url(#paint1_radial)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5617 38.3866L44.4459 24.5244C46.6869 23.325 46.409 21.2369 43.8205 19.8555C41.2321 18.4741 37.3118 18.3241 35.0709 19.5182L9.18666 33.3804C6.94567 34.5797 7.22363 36.6679 9.81205 38.0493C12.4005 39.436 16.3207 39.586 18.5617 38.3866Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69033 37.8245C12.2788 39.2059 16.199 39.3558 18.44 38.1618L44.3242 24.2996C45.465 23.6892 45.9514 22.8486 45.8124 21.9866C46.2872 23.0253 45.8645 24.0962 44.4864 24.8297L18.6021 38.6919C16.3612 39.8913 12.4409 39.7413 9.85247 38.3546C8.58432 37.6746 7.86628 36.8286 7.73309 35.9987C8.03421 36.6519 8.68855 37.2944 9.69033 37.8245Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2275 22.9984C32.2275 24.2299 34.0806 25.2258 36.3679 25.2258C38.6552 25.2258 40.5082 24.2299 40.5082 22.9984C40.5082 21.7669 38.6552 20.771 36.3679 20.771C34.0806 20.771 32.2275 21.7669 32.2275 22.9984Z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6265 33.9427C12.6265 35.1742 14.4795 36.1701 16.7668 36.1701C19.0541 36.1701 20.9071 35.1742 20.9071 33.9427C20.9071 32.7112 19.0541 31.7153 16.7668 31.7153C14.4795 31.7153 12.6265 32.7112 12.6265 33.9427Z",
    fill: "url(#paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27 43.7355C27 41.1016 29.0169 37.8962 31.5 36.5709C33.9831 35.2457 36 36.3059 36 38.9398C36 40.7123 35.0857 42.7499 33.7231 44.2904V52.6311L29.2769 55V46.6593C27.9143 46.5599 27 45.508 27 43.7355Z",
    fill: "#25054D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.088 51.7533V43.4129C33.296 41.8724 34.12 39.8349 34.12 38.0625C34.12 37.2011 33.92 36.5054 33.584 36.0084C35.008 35.8925 36 36.9775 36 38.9404C36 40.7128 35.184 42.7503 33.968 44.2908V52.6312L30 55V53.0039L32.088 51.7533Z",
    fill: "url(#paint6_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2 1.353C30.4267 -2.49672 39.4543 2.32748 39.4543 10.0376V23.2573C39.4543 23.2627 39.4543 23.2734 39.4543 23.2788C39.4543 24.3389 37.8619 25.1956 35.8931 25.1956C33.9243 25.1956 32.3318 24.3389 32.3318 23.2788C32.3318 23.268 32.3376 23.252 32.3376 23.2413H32.2971V11.4458C32.2971 8.1797 28.4753 6.13437 25.412 7.76207C21.8566 9.65212 19.6619 13.1538 19.6619 16.95V34.1479H19.6214C19.5808 35.1867 18.0058 36.0273 16.0659 36.0273C14.1145 36.0273 12.5278 35.1813 12.5104 34.1319V18.4438C12.5104 11.3923 16.5871 4.87076 23.2 1.353Z",
    fill: "url(#paint7_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M18.5037 34.987H18.5153V18.4744C18.5153 14.9566 20.3046 11.6584 23.2694 9.54346C21.1964 11.6049 19.9803 14.3462 19.9803 17.2322V33.7448H19.9687L19.9456 34.4034C19.9282 34.7996 19.3549 35.2279 18.4863 35.4581L18.5037 34.987Z",
    fill: "#D3DBE2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M35.1926 11.685V24.3371C34.3877 24.1069 33.8608 23.7053 33.8376 23.3252V23.3144L33.8029 22.5863V11.4601C33.8029 9.25948 32.2394 7.39084 30.0795 6.75903C32.9169 6.86612 35.1926 9.0346 35.1926 11.685Z",
    fill: "url(#paint8_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M19.7449 17.1351C19.3162 14.5459 19.5146 10.8367 22.7057 7.47993C25.6798 4.35033 29.3806 3.43536 31.4647 6.26767C30.596 5.84749 29.6017 5.61917 28.5486 5.65541C27.5475 5.68986 26.5565 5.97578 25.6843 6.47729C21.845 8.69902 19.5653 12.6727 19.7337 16.8569L19.7449 17.1351Z",
    fill: "#85B5DF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 7.29442,
    y1: 43.9664,
    x2: 46.1988,
    y2: 43.9664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0606,
    stopColor: "#8585DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.287,
    stopColor: "#A3A3ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9949,
    stopColor: "#8888E2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.5069 49.2728) rotate(180) scale(3.51961 12.828)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0152,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 25.4313,
    y1: 12.3088,
    x2: 27.0286,
    y2: 34.7653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0369,
    stopColor: "#7B7BC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3A3ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 41.7705,
    y1: 26.2359,
    x2: 12.8912,
    y2: 38.4842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3A3ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.950596,
    stopColor: "#D2D2F7",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 33.8258,
    y1: 20.9097,
    x2: 39.2924,
    y2: 26.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B61B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 14.2267,
    y1: 31.854,
    x2: 19.6933,
    y2: 37.1093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B61B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 47.7054,
    y1: 47.2318,
    x2: 27.8219,
    y2: 45.1923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3012,
    stopColor: "#383874"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5007,
    stopColor: "#454498"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9419,
    stopColor: "#6563F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6967FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 28.0265,
    y1: -13.0039,
    x2: 26.2785,
    y2: 36.0378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.380208,
    stopColor: "#CBE2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864583,
    stopColor: "#BCDAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95C4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 28.6384,
    y1: 17.8007,
    x2: 39.5848,
    y2: 10.5879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9E9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2C4E7"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.e7542d14.svg";
export { ForwardRef as ReactComponent };